import { useEffect, useMemo } from 'react';
import debounce from 'lodash.debounce';

const DebounceSearch = (callback: (...arg: any) => void, delay: number) => {
  const debouncedResults = useMemo(() => {
    return debounce(callback, delay || 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  return { debouncedResults };
};

export default DebounceSearch;
